var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',_vm._g(_vm._b({class:[
    'cursor-pointer hover:text-gray-600',
    _vm.active ? 'text-control-high' : 'text-gray-500'
  ],attrs:{"name":"view-grid","aria-hidden":"true"}},'b-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }